module.exports = __webpack_public_path__ + "41cff383b02b9e641ea24075d0d9b166.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/crayons.png
// module id = 2625
// module chunks = 0